import startCase from 'lodash/startCase';

export interface RadioFilterProps<T extends string | number> {
  enumObj: object;
  value: T | null;
  onChange: (value: T | undefined) => void;
  name?: string;
  className?: string;
  orientation?: 'horizontal' | 'vertical';
}

export const RadioFilter = <T extends string | number>({
  enumObj,
  value,
  onChange,
  name = 'radioFilter',
  className = '',
  orientation = 'horizontal'
}: RadioFilterProps<T>) => {
  const options = Object.entries(enumObj)
    .filter(([key, val]) => isNaN(Number(key)) && typeof val !== 'string')
    .map(([key, enumValue]) => ({
      id: `${name}-${key.toLowerCase()}`,
      value: enumValue as T,
      label: startCase(key)
    }));

  const containerClass = orientation === 'horizontal' ? 'd-flex mt-1' : 'd-flex flex-column gap-2 mt-1';

  return (
    <div className={`${containerClass} ${className}`}>
      {options.map((option) => (
        <div
          key={option.id}
          className="form-check form-check-custom form-check-secondary form-check-solid form-check-inline mx-2 d-flex align-items-center"
        >
          <input
            className="form-check-input"
            type="radio"
            name={name}
            id={option.id}
            checked={value === option.value}
            onChange={() => onChange(option.value)}
          />
          <label htmlFor={option.id} className="ms-3 text-nowrap cursor-pointer">
            {option.label}
          </label>
        </div>
      ))}
    </div>
  );
};
